import { render, staticRenderFns } from "./DetailExperienceFormItem.vue?vue&type=template&id=48018444&scoped=true"
import script from "./DetailExperienceFormItem.vue?vue&type=script&lang=js"
export * from "./DetailExperienceFormItem.vue?vue&type=script&lang=js"
import style0 from "./DetailExperienceFormItem.vue?vue&type=style&index=0&id=48018444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48018444",
  null
  
)

export default component.exports